import { render } from "./dialogue.vue?vue&type=template&id=60eaef23"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/dialogue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60eaef23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60eaef23', __exports__)) {
    console.log('reload')
    api.reload('60eaef23', __exports__)
  }
  
  module.hot.accept("./dialogue.vue?vue&type=template&id=60eaef23", () => {
    console.log('re-render')
    api.rerender('60eaef23', render)
  })

}


export default __exports__